import { createContext, useContext } from "react";

const TaskFormContext = createContext({});

export const TaskFormContextProvider = TaskFormContext.Provider;
export const TaskFormContextConsumer = TaskFormContext.Consumer;

export const useTaskFormContext = () => useContext(TaskFormContext);

export default TaskFormContext;
